import React from "react";
import { connect } from "react-redux";
import { Marker, LayerGroup } from "react-leaflet";
import { SegmentIcon } from "./Icons";
import _ from "lodash";
import { distanceToRouteCoordinate } from "components/util/GeometryUtilsV2";
import { routeGeomSelector } from "redux/selectors";

class ShortcutMarkers extends React.PureComponent {
    renderShortcutMarkers = () => {
        let markerIconToUse = SegmentIcon;

        const markers = [];

        if (this.props.viewingRouteData.video && this.props.viewingRouteData.video[this.props.sourceIndex] && this.props.shortcutMarkers.length) {
            const startDistance = Math.min(...this.props.shortcutMarkers);
            const endDistance = Math.max(...this.props.shortcutMarkers);

            const routePosData = _.get(this.props.geometryData, ["distance_to_coordinate"], []);

            const startCoords = distanceToRouteCoordinate(startDistance, routePosData);

            if (startCoords !== null) {
                let coords = [startCoords[1], startCoords[0]];
                markers.push(
                    <Marker
                        position={coords}
                        icon={markerIconToUse}
                    />,
                );
            }

            const endCoords = distanceToRouteCoordinate(endDistance, routePosData);
            if (endCoords !== null) {
                let coords = [endCoords[1], endCoords[0]];
                markers.push(
                    <Marker
                        position={coords}
                        icon={markerIconToUse}
                    />,
                );
            }
        }
        return markers;
    };

    render() {
        return <LayerGroup>{this.renderShortcutMarkers()}</LayerGroup>;
    }
}

const mapStateToProps = (state) => {
    const allPoints = _.get(state.shortcuts.shortcutSessionPoints, [state.playlist.data.routeID], []).flatMap((ranges) => {
        return ranges;
    });

    return {
        shortcutMarkers: allPoints,
        sourceIndex: state.playlist.position.sourceIndex,
        viewingRouteData: state.playlist.data,
        use_snapped: state.snappedRoute || false,
        geometryData: routeGeomSelector(state),
    };
};

export default connect(mapStateToProps)(ShortcutMarkers);
